
import React, { useContext, useEffect, useState } from 'react'
import { useBooks } from '@hooks/useBooks'
import { AppContext } from '@state/context'
import { closePanel, openPanel } from '@state/actions/panelsActions'
import Button from '@components/Button'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
import {
  PANELS,
  DIVIDER_SIZE,
  BUTTON_SIZE,
  HEADING_TYPE,
  BUTTON_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import Text from '@components/Text'
import Form from '@components/Form'
import { Controller, useForm } from 'react-hook-form'
import ButtonWithLoader from '@components/ButtonWithLoader'
import { useUpdateBook } from '@hooks/mutations/useUpdateBook'
import BookOption from './BookOption'
import { setCurrentAddSectionToBookObject } from '@state/actions/appActions'

const AddSectionToBookPanel = () => {
    const [state, dispatch] = useContext(AppContext)
    const {
        app: { currentSection },
    } = state
    const [bookOptions, setBookOptions] = useState([])
    const [selectedBookValue, setSelectedBookValue] = useState(undefined)
    const {
        userCreatedBooks: books,
        isLoading,
    } = useBooks()
    const { handleSubmit, errors, control, getValues } = useForm()
    const { post, isPosting } = useUpdateBook()

    useEffect(() => {
        if (books.length > 0 && bookOptions.length === 0) {
            const subjectBooks = books.filter(book => book.subject.id === currentSection.subject.id)

            setBookOptions(subjectBooks.map((book) => ({
                name: book.name,
                value: book.id,
                hasSection: book.sections.some(section => section.id === currentSection.id),
                disabled: book.sections.some(section => section.id === currentSection.id),
                book: book,
            })))
        }
    }, [books])

    const onSubmit = async (data) => {
        await post(
            {
                id: data.book,
                connectSections: [currentSection.id],
            },
            'Avsnitt tillagt.',
            'Nåt gick fel när avsnittet skulle läggas till.'
        )

        dispatch(closePanel(PANELS.ADD_SECTION_TO_BOOK))
    }

    return (
        <>
            <div className='flex justify-end items-center'>
                <Button
                    handleClick={() => {
                        dispatch(closePanel(PANELS.ADD_SECTION_TO_BOOK))
                    }}
                    size={BUTTON_SIZE.NO_PADDING}
                    icon={'Close'}
                ></Button>
            </div>

            {!isLoading && (!books || !bookOptions.length) && (
                <div className='mx-auto h-full max-w-[300px] text-center'>
                    <Heading
                        headingLevel={HEADING_TYPE.H2}
                        size={TEXT_SIZES.LARGE}
                        >
                        Skapa en bok som du kan lägga avsnittet i.
                    </Heading>

                    <Divider size={DIVIDER_SIZE.MEDIUM} />

                    <Button
                        handleClick={() => {
                            dispatch(setCurrentAddSectionToBookObject(currentSection))
                            dispatch(closePanel(PANELS.ADD_SECTION_TO_BOOK))
                            dispatch(openPanel(PANELS.CREATE_BOOK))
                        }}
                        type={BUTTON_TYPE.PRIMARY}
                        size={BUTTON_SIZE.LARGE}
                        iconLeft
                        icon={'Book'}
                    >
                        Skapa bok
                    </Button>
                </div>
            )}

            {!isLoading && bookOptions?.length > 0 &&
                <>
                    <div className={'text-center'} >
                        <Heading
                            headingLevel={HEADING_TYPE.H2}
                            size={TEXT_SIZES.LARGE}
                        >
                            {currentSection?.name}
                        </Heading>
                    </div>

                    {bookOptions && (
                        <Form onSubmit={handleSubmit(onSubmit)} className={'flex flex-col items-center justify-center'}>
                            <Text>Lägg till i bok:</Text>
                            <Controller
                                control={control}
                                name={'book'}
                                defaultValue={[]}
                                rules={{
                                    validate: (value) => {
                                        return getValues('book').length > 0
                                    },
                                }}
                                render={(
                                    { onChange, onBlur, value, name, ref }
                                ) => (
                                    <Form.MultiSelect
                                        // defaultValue={value}
                                        placeholder={'Välj...'}
                                        name={name}
                                        onChange={(option) => {
                                            setSelectedBookValue(option.value)
                                            onChange(option.value)
                                        }}
                                        options={bookOptions}
                                        components={{ Option: BookOption }}
                                        maxWidth={'500px'}
                                    />
                                )}
                            />
                            {errors.book && (
                                <Form.ErrorMessage>
                                    Välj en eller flera böcker
                                </Form.ErrorMessage>
                            )}

                            <Divider size={DIVIDER_SIZE.SMALL} />

                            <div className="flex items-center">
                                <ButtonWithLoader
                                    type={BUTTON_TYPE.PRIMARY}
                                    isLoading={isPosting}
                                    disabledText={'Lägg till'}
                                    enabledText={'Lägg till'}
                                    disabled={isPosting || !selectedBookValue}
                                    margin
                                />

                                <Button
                                    handleClick={() => {
                                        dispatch(setCurrentAddSectionToBookObject(currentSection))
                                        dispatch(closePanel(PANELS.ADD_SECTION_TO_BOOK))
                                        dispatch(openPanel(PANELS.CREATE_BOOK))
                                    }}
                                    type={BUTTON_TYPE.PRIMARY_OUTLINE}
                                    size={BUTTON_SIZE.LARGE}
                                    margin
                                    nativeTypeAttribute={'button'}
                                >
                                    Skapa bok
                                </Button>
                            </div>
                        </Form>
                    )}
                </>
            }
        </>
    )
}

export default AddSectionToBookPanel
